import {Trans} from 'gatsby-plugin-react-i18next';
import React from 'react';

import {countries} from './common';


/*
 * Private Elements
 */
const formattedCountriesList = Object.entries(countries).map(([key, name]) => ({key, name}));

const paymentMethodTypes = {
    card: <Trans>Card</Trans>,
    eInvoice: <Trans>eInvoice</Trans>,
    eWallet: <Trans>eWallet</Trans>,
    eVoucher: <Trans>E-Voucher</Trans>,
    prePayment: <Trans>Pre-Payment</Trans>,
    postPayment: <Trans>Post-Payment</Trans>,
    onlineBankTransfer: <Trans>Online Bank Transfer</Trans>,
    offlineBankTransfer: <Trans>Offline Bank Transfer</Trans>,
    directDebit: <Trans>Direct Debit</Trans>,
    carrierBilling: <Trans>Carrier Billing</Trans>,
};

const paymentProviderTypes = {
    acquirer: <Trans>Acquirer</Trans>,
    gateway: <Trans>Gateway</Trans>,
    psp: <Trans>PSP</Trans>,
    securityVendor: <Trans>Security Vendor</Trans>,
};


/*
 * Public Elements
 */

// Channel status
const liveStatus = 'LIVE';
const onRequestStatus = 'ON_REQUEST';

// Channels filters
const channelsFiltersSchema = {
    /* eslint-disable i18next/no-literal-string */
    region: {
        type: 'array',
        operator: 'objectValue',
        path: 'payment_method.countries',
        name: <Trans>Region</Trans>,
    },
    shopper_country: {
        type: 'array',
        operator: 'contains',
        path: 'payment_method.countries',
        name: <Trans>Shopper Country</Trans>,
        options: formattedCountriesList,
    },
    payment_provider_name: {
        type: 'string',
        operator: 'equals',
        path: 'payment_provider.name',
        name: <Trans>Provider Name</Trans>,
    },
    payment_provider_type: {
        type: 'string',
        operator: 'equals',
        path: 'payment_provider.type',
        name: <Trans>Provider Type</Trans>,
        options: Object.entries(paymentProviderTypes).map(([key, name]) => ({key, name})),
    },
    payment_method_name: {
        type: 'string',
        operator: 'equals',
        path: 'payment_method.name',
        name: <Trans>Payment Method Name</Trans>,
    },
    payment_method_type: {
        type: 'string',
        operator: 'equals',
        path: 'payment_method.type',
        name: <Trans>Payment Method Type</Trans>,
        options: Object.entries(paymentMethodTypes).map(([key, name]) => ({key, name})),
    },
    status: {
        type: 'string',
        operator: 'equals',
        name: <Trans>Status</Trans>,
        options: [
            {name: <Trans>Live</Trans>, key: liveStatus},
            {name: <Trans>On Request</Trans>, key: onRequestStatus},
        ],
    },
    /* eslint-enable i18next/no-literal-string */
};


/*
 * Exports
 */
export {
    channelsFiltersSchema,
    liveStatus,
    onRequestStatus,
    paymentMethodTypes,
    paymentProviderTypes,
};
